export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=elegant%20fashion%20boutique%20storefront%20in%20Taichung%20Taiwan%20warm%20cream%20beige%20interior%20with%20clothing%20racks%20minimalist%20decor%20soft%20golden%20lighting%20inviting%20atmosphere%20high%20end%20retail%20exterior%20artistic%20editorial%20photography%20wide%20angle&width=1440&height=520&seq=about-hero-bg&orientation=landscape"
        alt="關於我們"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <span className="inline-block border border-white/60 text-white text-sm font-sans tracking-widest px-5 py-1.5 rounded-full mb-5 font-medium">
          ABOUT US
        </span>
        <h1 className="font-serif text-[2rem] md:text-[2.75rem] text-white font-semibold leading-[1.3] mb-5 max-w-2xl">
          關於我們
        </h1>
        <p className="font-sans text-[1.1875rem] text-white/85 leading-[1.75] max-w-xl">
          一間在台中誕生的女性服飾 Outlet，以正品、透明與溫度，重新定義時尚的取得方式。
        </p>
      </div>
    </section>
  );
}
